import React from 'react'
import { storiesOf } from '@storybook/react'
import withReadme from 'storybook-readme/with-readme'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import PrimaryButton from './PrimaryButton'
import readme from './readme.md'

// Story Setup
const stories = storiesOf('Digital-Commons/PrimaryButton', module)

stories.addDecorator(withReadme(readme))

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <div style={{ width: '75%', margin: '100px auto' }}>
        <PrimaryButton onClick={e => alert('You clicked on a PrimaryButton.')}>
          I am a Primary Button
        </PrimaryButton>
      </div>
    </ThemeProvider>
  ))
